const React = require("react");

export default () => (
  <span className="exclamation">!</span>
);
